import { render } from "./NavSidebarNew.vue?vue&type=template&id=2ed0e1d5"
import script from "./NavSidebarNew.vue?vue&type=script&lang=js"
export * from "./NavSidebarNew.vue?vue&type=script&lang=js"

import "./NavSidebarNew.vue?vue&type=style&index=0&id=2ed0e1d5&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__